/**
 * @file utils/path/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */
import { getString } from "config-api";

// By default canonical URL is using appState.path unless specified in the exception list below.
// This exception is currently only used for homepage to avoid "cbc.ca/homepage" to be generated. List might grow in future.
export const CANONICAL_PATH_EXCEPTION = {
    homepage: "",
    "sports/olympics/summer": "https://www.cbc.ca/sports/olympics",
};

export const ENVIRONMENT_DOMAIN = getString("Client.environment.domain");
